module.exports = __webpack_public_path__ + "static/media/station-cover.d84344b8.png";